import { App, UrlSerializer } from 'ionic-angular';

/**
 * Pages that must never be reachable from the browser address bar.
 *
 * Hiding a side menu button is not enough on the online build: every
 * `@IonicPage()` also gets a deep-link segment, so a customer could type
 * e.g. `#/update-address` or `#/online-setting` and land on a page that has no
 * side menu entry at all.
 *
 * Two groups are listed here:
 *  1. Profile child pages - only ever entered from MyDetailsPage, which is
 *     itself gated on the `menu_updateprofile` bank setting.
 *  2. Pages whose side menu buttons are commented out in web/home/home.html,
 *     so they are not offered to the customer at all.
 */
export const URL_BLOCKED_PAGES: string[] = [
  // Profile child pages
  'ProfileUpdatePage',
  'UpdateAddressPage',
  'UpdateEmailaddressPage',
  'UpdatePhonenumberPage',
  // Payment child page - only ever pushed by OnlinePaymentPage with the
  // payment_url / reference_id nav params, which a deep link cannot supply.
  'ProcessPaymentPage',
  // No side menu entry
  'OnlineBranchesPage',
  'OnlineChatPage',
  'OnlineMessagesPage',
  'OnlineNewsPage',
  'OnlineProductPage',
  'OnlineSettingPage',
  'OnlineTransferPage',
  'OnlineUpdatebankPage',
];

/**
 * Drops the blocked pages while a browser URL is being parsed, which makes
 * their deep-link segments unroutable: DeepLinker gets no segment for them and
 * the nav falls back to its configured root instead.
 *
 * In-app navigation is unaffected - `setRoot("SomePage")` resolves the name via
 * `getLinkFromName()`, which this class deliberately leaves alone.
 */
export class BlockedUrlSerializer extends UrlSerializer {
  parse(browserUrl: string): any[] {
    return super.parse(browserUrl)
      .filter((segment: any) => URL_BLOCKED_PAGES.indexOf(segment.name) < 0);
  }
}

export function setupBlockedUrlSerializer(app: App, userDeepLinkConfig: any) {
  return new BlockedUrlSerializer(app, userDeepLinkConfig);
}



// WEBPACK FOOTER //
// ./src/app/url-guard.ts